// extracted by mini-css-extract-plugin
var _1 = "ShoppingCredit_checkbox__X8Eok";
var _2 = "ShoppingCredit_checkboxContainer__DqBjU";
var _3 = "ShoppingCredit_checkboxLabel__azPl0";
var _4 = "ShoppingCredit_disclaimer__mq0jg";
var _5 = "ShoppingCredit_pinkShoppingCreditContainer__-FgPW";
var _6 = "ShoppingCredit_shoppingCreditContainer__JQVzh";
export { _1 as "checkbox", _2 as "checkboxContainer", _3 as "checkboxLabel", _4 as "disclaimer", _5 as "pinkShoppingCreditContainer", _6 as "shoppingCreditContainer" }
